import React, { FunctionComponent, ReactNode } from 'react';

export interface PageLayoutHeaderProps {
  children: ReactNode,
}

const PageLayoutHeader: FunctionComponent<PageLayoutHeaderProps> = ({
  children,
  ...rest
}) => (
  <header {...rest}>
    {children}
  </header>
);

export default PageLayoutHeader;
